// React Required
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import processPolyfill from 'process';

// Create Import File
import './index.scss';

import PageScrollTop from './component/PageScrollTop';

// Core pages (CTO-facing portfolio)
import PortfolioLanding from './home/PortfolioLanding';
import Contact from "./elements/Contact";
import EnterpriseAI from "./elements/EnterpriseAI";
import RecentWork from "./elements/RecentWork";
import ReferenceArchitectures from "./elements/ReferenceArchitectures";
import CaseStudy from "./elements/CaseStudy";
import Runbook from "./elements/Runbook";
import Archive from "./elements/Archive";
import Error404 from "./elements/error404";

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = processPolyfill;
}

const Root = () => (
    <BrowserRouter
        basename="/"
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
        <PageScrollTop>
            <Routes>
                <Route path="/" element={<PortfolioLanding />} />
                <Route path="/case-studies/:slug" element={<CaseStudy />} />
                <Route path="/case-studies" element={<Navigate replace to="/recent-work" />} />
                <Route path="/reference-architectures" element={<ReferenceArchitectures />} />
                <Route path="/recent-work" element={<RecentWork />} />
                <Route path="/enterprise-ai" element={<EnterpriseAI />} />
                <Route path="/runbooks/:slug" element={<Runbook />} />
                {/* Resume unpublished: the PDF carried personal contact details.
                    Redirect rather than 404 so existing links keep working. */}
                <Route path="/resume" element={<Navigate replace to="/contact" />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/archive" element={<Archive />} />

                {/* Legacy project pages (kept for now) */}
                <Route path="/des" element={<Navigate replace to="/archive#des" />} />
                <Route path="/genomics" element={<Navigate replace to="/archive#genomics" />} />
                <Route path="/higgs" element={<Navigate replace to="/archive#higgs" />} />
                <Route path="/stocks" element={<Navigate replace to="/archive#stocks" />} />
                <Route path="/physics" element={<Navigate replace to="/archive#physics" />} />

                <Route path="/404" element={<Error404 />} />
                <Route path="*" element={<Error404 />} />
            </Routes>
        </PageScrollTop>
    </BrowserRouter>
);

const container = document.getElementById('root');
const app = (
    <React.StrictMode>
        <Root />
    </React.StrictMode>
);

if (container && container.hasChildNodes()) {
    hydrateRoot(container, app);
} else if (container) {
    const root = createRoot(container);
    root.render(app);
}
// Disable the service worker by default to avoid "stale site" caching issues on a portfolio site.
serviceWorker.unregister();
